<template>
  <div id="app" class="w100 h100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
